import { Axios } from 'utils'
import { TProduct, TProductWithId } from 'types/models'
import {
  ItemResponseType,
  ListPaginationParams,
  ListResponseType,
} from './types'

export const useProductsService = () => {
  const getProducts = async (pagination?: ListPaginationParams) => {
    try {
      const response = await Axios.get<ListResponseType<TProductWithId>>(
        '/products',
        {
          params: pagination
            ? {
                offset: pagination.currentPage * pagination.itemsPerPage,
                limit: pagination.itemsPerPage,
              }
            : undefined,
        }
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const createProduct = async (params: TProduct) => {
    try {
      const response = await Axios.post<ItemResponseType<TProduct>>(
        '/products',
        params
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const updateProduct = async (params: TProduct) => {
    try {
      const response = await Axios.put<ItemResponseType<TProduct>>(
        `/products/${params.id}`,
        params
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const getProductById = async (id: string) => {
    try {
      const response = await Axios.get<ItemResponseType<TProduct>>(
        `/products/${id}`
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const deleteProduct = async (id: number) => {
    try {
      const response = await Axios.delete<{ status: boolean; detail: string }>(
        `/products/${id}`
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  return {
    getProducts,
    createProduct,
    updateProduct,
    getProductById,
    deleteProduct,
  }
}
